import React from 'react';
import styled from 'styled-components';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
// import 'react-accessible-accordion/dist/minimal-example.css';

import {
  screen,
  CONTAINED,
  COLOR_BORDER_GRAY,
  COLOR_GREEN,
} from '../common/variables';
import {
  DESC,
  DIMENSIONS,
  ACCESSORIES,
  CUSTOMISE,
  CPDIMENSIONS,
  CIRCULAR_ECO,
} from './tablabels';
import { TabContent } from './TabContent';

const Wrapper = styled.div`
  h6 {
    font-size: 0.8rem !important;
    font-weight: 300 !important;
  }
  p {
    margin-bottom: 10px !important;
  }
  ${CONTAINED}
  display: flex;
  padding: 3rem 0;
  justify-content: space-between;
  a {
    color: #69ad3f;
    border-bottom: 1px solid #69ad3f;
  }
  .accordion {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-content: flex-start;
    padding: 25px;
    font-family: 'Source Sans Pro', sans-serif;
    justify-content: space-around;
  }
  .accordion-content {
    padding-top: 20px;
    width: auto;
    padding-right: 19px;
  }
  .accordion-title {
    font-weight: 500;
    font-family: 'Source Sans Pro', sans-serif;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .plusSign {
      font-size: 30px;
      padding: 0px 20px;
    }
  }
  .accordion-item {
    margin: 15px 0px;
    width: 100%;
    padding-bottom: 10px;
    border-bottom: 1px solid black;
  }
  .accordion-item:hover {
    cursor: pointer;
  }
  .accordion-desktop {
    display: none;
    padding: 0 35px;
    @media ${screen.largeXL} {
      display: flex;
      width: 100%;
    }
    @media ${screen.largeXXL} {
      padding: 0;
    }
  }
  .accordion-mobile {
    display: flex;
    width: 100%;
    @media ${screen.largeXL} {
      display: none;
    }

    .accordion-item {
      .accordion__button {
        display: flex;
        justify-content: space-between;
        width: 100%;
      }
    }
  }

  input[type='radio'] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .tab-labels {
    min-width: 185px;
    margin-right: 3rem;
  }
  .tab-label {
    cursor: pointer;
    display: block;
    padding: 1rem;
    color: #3a3a3a;
    border-bottom: 1px solid ${COLOR_BORDER_GRAY};
    &.selected {
      color: ${COLOR_GREEN};
    }
  }
`;

class Tabs extends React.Component {
  state = {
    currentTab: `${DESC}`,
    opened: null,
  };
  handleTabChange = (e) => {
    e.preventDefault();
    if (e.target.id && e.target.name === 'tab') {
      this.setState({
        currentTab: e.target.id,
      });
    }
  };
  render() {
    const { currentTab } = this.state;

    return (
      <Wrapper>
        <div className="accordion-desktop">
          <form className="tab-labels" onChange={this.handleTabChange}>
            <label
              className={'tab-label' + (currentTab === DESC ? ' selected' : '')}
            >
              <input type="radio" id={DESC} name="tab" />
              Description
            </label>
            {this.props.cpdimensions ? (
              <label
                className={
                  'tab-label' + (currentTab === CPDIMENSIONS ? ' selected' : '')
                }
              >
                <input type="radio" id={CPDIMENSIONS} name="tab" />
                Dimensions
              </label>
            ) : (
              <label
                className={
                  'tab-label' + (currentTab === DIMENSIONS ? ' selected' : '')
                }
              >
                <input type="radio" id={DIMENSIONS} name="tab" />
                Dimensions
              </label>
            )}
            <label
              className={
                'tab-label' + (currentTab === ACCESSORIES ? ' selected' : '')
              }
            >
              <input type="radio" id={ACCESSORIES} name="tab" />
              Accessories
            </label>
            <label
              className={
                'tab-label' + (currentTab === CUSTOMISE ? ' selected' : '')
              }
            >
              <input type="radio" id={CUSTOMISE} name="tab" />
              Custom Design
            </label>

            <label
              className={
                'tab-label' + (currentTab === CIRCULAR_ECO ? ' selected' : '')
              }
            >
              <input type="radio" id={CIRCULAR_ECO} name="tab" />
              Circular Economy
            </label>
          </form>
          <TabContent tab={currentTab} content={this.props[currentTab]} />
        </div>
        <div className="accordion-mobile">
          <Accordion allowZeroExpanded={true} className="accordion">
            {Object.keys(nameMap)
              .filter((key) => {
                if (nameMap[key] === DIMENSIONS && this.props.cpdimensions)
                  return false;
                if (nameMap[key] === CPDIMENSIONS && !this.props.cpdimensions)
                  return false;
                return true;
              })
              .map((key) => (
                <AccordionItem
                  className="accordion-item"
                  key={key}
                  onClick={() =>
                    this.setState((state) => ({
                      opened: state.opened === key ? null : key,
                    }))
                  }
                >
                  <AccordionItemHeading className="accordion-title">
                    <AccordionItemButton>
                      <div>{key}</div>
                      <div className="plusSign">
                        {this.state.opened !== key ? '+' : '-'}
                      </div>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel className="accordion-content">
                    <TabContent
                      mobile
                      tab={nameMap[key]}
                      content={this.props[nameMap[key]]}
                    />
                  </AccordionItemPanel>
                </AccordionItem>
              ))}
          </Accordion>
        </div>
      </Wrapper>
    );
  }
}

export default Tabs;

const nameMap = {
  Description: DESC,
  Dimensions: DIMENSIONS,
  Accessories: ACCESSORIES,
  Customise: CUSTOMISE,
  'Circular Economy': CIRCULAR_ECO,
  'Compost-a-Pak Dimensions': CPDIMENSIONS,
};
